<footer class="footer">
  <div class="footer-links">
    <span class="footer-support">
      <span class="footer-support__label">{{ 'footer.support.label' | translate }}</span>
      <a class="footer-support-link" href="mailto:{{ 'footer.support.email' | translate }}">
        {{ 'footer.support.email' | translate }}
      </a>
    </span>
    <button type="button" class="footer-privacy-link" lang="en" (click)="openPrivacyNotice()">
      {{ 'footer.privacy_notice.link' | translate }}
    </button>
  </div>
  <span class="footer-copyright">TotalEnergies - MultiProduct Studio {{ currentYear }} ©</span>
</footer>
